module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "student"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "add-user"
  }, [_c('p', [_vm._v("开启您在知心慧学的全新旅程吧！")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Home',
        params: {
          status: 1
        }
      }
    }
  }, [_c('button', {
    staticClass: "btn-add"
  }, [_vm._v("加入知心慧学")])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "bangzhu"
  }, [_c('div', {
    staticClass: "title-box"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("我们为学生们在学习上带来什么帮助")]), _vm._v(" "), _c('i', {
    staticClass: "border-bottom"
  })]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('img', {
    staticClass: "card-img",
    attrs: {
      "src": require("../assets/img/img-ljzy.png"),
      "alt": "学习路径指引"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "card-name"
  }, [_vm._v("学习路径指引")]), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }, [_vm._v("知心慧学悉心收集每位学生每次考试答题数据，依据学生知识点掌握情况生成学生个人知识能力模型，为每位学生规划个性化学习路径，指导学生更加有针对性地学习。")])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('img', {
    staticClass: "card-img",
    attrs: {
      "src": require("../assets/img/img-ctgl.png"),
      "alt": "错题管理"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "card-name"
  }, [_vm._v("错题管理")]), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }, [_vm._v("系统自动整理学生每次考试出现的错题，节约学生自己整理错题的时间。并为每道试题匹配知识点、提供解题思路指导，便于学生订正复习，培养错题管理和回顾总结的学习意识。")])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('img', {
    staticClass: "card-img",
    attrs: {
      "src": require("../assets/img/img-jzlx.png"),
      "alt": "精准练习"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "card-name"
  }, [_vm._v("精准练习")]), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }, [_vm._v("每次考后，知心慧学为学生打印个性化学习方案，准确告知各知识点的掌握情况。为每道错题匹配变式训练题，帮助学生针对知识薄弱点进行更加有针对性的练习，脱离题海，提高练习效率。")])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('img', {
    staticClass: "card-img",
    attrs: {
      "src": require("../assets/img/img-msjj.png"),
      "alt": "重点教师讲解"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "card-name"
  }, [_vm._v("重点教师讲解")]), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }, [_vm._v("知心慧学在假期开展网络直播课，针对典型学习问题和重难点，聘请教师进行针对性讲解，让学生进一步掌握相关知识。")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "separate"
  }, [_c('img', {
    staticClass: "img-separate",
    attrs: {
      "src": require("../assets/img/img-separate.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "txpj"
  }, [_c('div', {
    staticClass: "title-box"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("看看使用知心慧学的同学怎么说")]), _vm._v(" "), _c('i', {
    staticClass: "border-bottom"
  })]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('img', {
    staticClass: "img-zxhx",
    attrs: {
      "src": require("../assets/img/img-zxhx.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card bg-card-lt"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('img', {
    staticClass: "img-student-head",
    attrs: {
      "src": require("../assets/images/ltx.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("李同学")]), _vm._v(" "), _c('span', {
    staticClass: "school"
  }, [_vm._v("湖北省南漳一中")])]), _vm._v(" "), _c('p', {
    staticClass: "bottom"
  }, [_vm._v("\n            我的数学成绩一直处于中下水平，即使语文和英语成绩很好，但是数学一直是我成绩的薄弱项，在使用了一个学期的产品后，知心慧学帮我逐步攻克了自己数学知识点上的薄弱环节，同时给予详细的解题思路，帮助我成长！")])])]), _vm._v(" "), _c('div', {
    staticClass: "card bg-card-rt"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('img', {
    staticClass: "img-student-head",
    attrs: {
      "src": require("../assets/images/dtx.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("代同学")]), _vm._v(" "), _c('span', {
    staticClass: "school"
  }, [_vm._v("宣威七中")])]), _vm._v(" "), _c('p', {
    staticClass: "bottom"
  }, [_vm._v("\n            之前天天刷题，题目做了无数，但是数学成绩还是上不去，始终在80-90分徘徊。知心慧学最大的好处就是：让我刷题更有针对性了，哪里不会就练哪里。现在，我对数学考试的信心得到了进一步提高。")])])]), _vm._v(" "), _c('div', {
    staticClass: "card bg-card-rb"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('img', {
    staticClass: "img-student-head",
    attrs: {
      "src": require("../assets/images/ztx.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("张同学")]), _vm._v(" "), _c('span', {
    staticClass: "school"
  }, [_vm._v("河南夏邑高级中学")])]), _vm._v(" "), _c('p', {
    staticClass: "bottom"
  }, [_vm._v("\n            知心慧学错题本上面保留了我每次考试的作答原笔迹，还给每道错题配了老师指点，解析也非常详细。我会好好订正，保留好我每一个学期的错题本的，等到高三的时候再拿出来，应该会很有帮助！")])])]), _vm._v(" "), _c('div', {
    staticClass: "card bg-card-lb"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('img', {
    staticClass: "img-student-head",
    attrs: {
      "src": require("../assets/images/ctx.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("曹同学")]), _vm._v(" "), _c('span', {
    staticClass: "school"
  }, [_vm._v("沈阳市第27中学")])]), _vm._v(" "), _c('p', {
    staticClass: "bottom"
  }, [_vm._v("\n            数学一直是我的薄弱环节，过去我即使大量地做题也没有获得太大的提高，用了知心慧学之后，错题本针对自己的薄弱项进行针对性的训练给予了我事半功倍的学习方法，大大减轻了我的学习负担！")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22f4a4e0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Student.vue
// module id = 513
// module chunks = 2